module.exports = "<a href=\"#\" data-id=\"{{id}}\">{{title}}</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/linkDialog/templates/item.html
// module id = 1187
// module chunks = 0